import IconProps from "./icon-props";

export default function SearchIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M9.55729 15.8333C13.2392 15.8333 16.224 12.8486 16.224 9.16667C16.224 5.48477 13.2392 2.5 9.55729 2.5C5.87539 2.5 2.89062 5.48477 2.89062 9.16667C2.89062 12.8486 5.87539 15.8333 9.55729 15.8333Z" stroke="#000F33" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17.8906 17.5L14.2656 13.875" stroke="#000F33" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  )
}